import type {PropsWithChildren} from 'react';
import {clsx} from 'clsx';
import {isContainerQueryAvailable} from '../lib/container-query-with-fallback';
import styles from './link.module.css';

type Props = PropsWithChildren;

export function MediaUserLoginGuideLinks({children, ...props}: Props) {
  return (
    <div
      className={clsx(
        styles.links,
        isContainerQueryAvailable() ? styles.pressReleaseRoot : styles.screen,
      )}
      {...props}
    >
      {children}
    </div>
  );
}
